import React from 'react';
import { CustomerHero } from '../customerDetailsTypes';
import styles from './CustomerHeroCard.module.css';

interface CustomerHeroCardProps {
  hero: CustomerHero;
}

export const CustomerHeroCard: React.FC<CustomerHeroCardProps> = ({ hero }) => {
  return (
    <div className={styles.card}>
      <div className={styles.headerRow}>
        <div>
          <h2 className={styles.name}>
            {hero.name}
            {hero.isActive && <span className={styles.activeBadge}>Active</span>}
          </h2>
          <p className={styles.contact}>{hero.contact}</p>
        </div>
        <div className={styles.iconActions}>
          {hero.phone ? (
            <a href={`tel:${hero.phone}`} className={styles.iconBtn} title={`Call ${hero.phone}`}>📞</a>
          ) : (
            <button type="button" className={styles.iconBtn} disabled title="No phone on file">📞</button>
          )}
          {hero.email ? (
            <a href={`mailto:${hero.email}`} className={styles.iconBtn} title={`Email ${hero.email}`}>✉️</a>
          ) : (
            <button type="button" className={styles.iconBtn} disabled title="No email on file">✉️</button>
          )}
        </div>
      </div>

      <div className={styles.metaGrid}>
        <div>
          <p className={styles.metaLabel}>📞 Phone</p>
          <p className={styles.metaValue}>{hero.phone}</p>
        </div>
        <div>
          <p className={styles.metaLabel}>📍 Location</p>
          <p className={styles.metaValue}>{hero.location}</p>
        </div>
        <div>
          <p className={styles.metaLabel}>💳 Credit Status</p>
          <p className={styles.metaValue}>
            {hero.creditStatus} <span className={styles.green}>●</span>
          </p>
        </div>
        <div>
          <p className={styles.metaLabel}>📅 Last Visit</p>
          <p className={styles.metaValue}>{hero.lastVisit}</p>
        </div>
      </div>
    </div>
  );
};
